var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"width":_vm.width,"height":_vm.height,"src":_vm.data.Records[0].url}})])}
var staticRenderFns = []

export { render, staticRenderFns }